import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grey-form-card"
}
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Primary Contact")
const _hoisted_4 = { class: "card-parent" }
const _hoisted_5 = {
  key: 0,
  class: "card-row"
}
const _hoisted_6 = { class: "card-label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Name:")
const _hoisted_8 = { class: "card-value" }
const _hoisted_9 = {
  key: 1,
  class: "card-row"
}
const _hoisted_10 = { class: "card-label" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Job Title:")
const _hoisted_12 = { class: "card-value" }
const _hoisted_13 = {
  key: 2,
  class: "card-row"
}
const _hoisted_14 = { class: "card-label" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Email:")
const _hoisted_16 = { class: "card-value" }
const _hoisted_17 = { class: "card-label" }
const _hoisted_18 = { class: "card-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_UserIcon = _resolveComponent("UserIcon")
  const _component_WorkOutlineIcon = _resolveComponent("WorkOutlineIcon")
  const _component_EmailIcon = _resolveComponent("EmailIcon")
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")

  return (_ctx.contactItem)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            _createVNode("h6", null, "Contact person " + _toDisplayString(_ctx.index + 1), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.contact.is_primary_contact,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.contact.is_primary_contact = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPrimary($event)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "edit-button",
              onClick: _ctx.deleteContact
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeleteIcon)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "edit-button",
              onClick: _ctx.editContact
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EditIcon)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          (_ctx.contact.first_name && _ctx.contact.last_name)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_UserIcon),
                  _hoisted_7
                ]),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.contact.first_name) + " " + _toDisplayString(_ctx.contact.last_name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.contact.title)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_WorkOutlineIcon),
                  _hoisted_11
                ]),
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.contact.title), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.contact.email)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_EmailIcon),
                  _hoisted_15
                ]),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.contact.email), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.phoneNumbers, (phone, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "card-row",
              key: index
            }, [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_PhoneIcon),
                _createTextVNode("Phone " + _toDisplayString(index + 1) + ":", 1)
              ]),
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatPhone(phone.country_code, phone.phone_number)), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}